import client from './client'

export async function fetchServices() {
  return client.get('/services')
}
